(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/all-games/all-games.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/all-games/all-games.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useContext = _React.useContext,
  useRef = _React.useRef;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const GameGrid = svs.eInstant.shared.GameGrid;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const Icon = svs.ui.ReactIcon;
const _svs$eInstant$constan = svs.eInstant.constants,
  _svs$eInstant$constan2 = _svs$eInstant$constan.ROUTES,
  ALL_GAMES = _svs$eInstant$constan2.ALL_GAMES,
  LOBBY = _svs$eInstant$constan2.LOBBY,
  getSortOptionById = _svs$eInstant$constan.getSortOptionById,
  ALPHABETICAL = _svs$eInstant$constan.sortIds.ALPHABETICAL;
const AllGames = () => {
  var _getSortOptionById;
  const _svs$eInstant$shared$ = svs.eInstant.shared.components,
    InfoOverlay = _svs$eInstant$shared$.InfoOverlay,
    SortGames = _svs$eInstant$shared$.SortGames,
    Background = _svs$eInstant$shared$.Background;
  const history = useHistory();
  const _svs$eInstant$shared$2 = svs.eInstant.shared.hooks.useMetaTags(),
    update = _svs$eInstant$shared$2.update;
  const _useContext = useContext(svs.eInstant.store.RouterContext),
    gameUrl = _useContext.state.gameUrl;
  const ScrollToTop = svs.eInstant.components.ScrollToTop;
  const fetchAllGames = svs.eInstant.shared.util.fetchAllGames;
  const _svs$eInstant$shared$3 = svs.eInstant.shared.hooks.useLocalStorage(ALL_GAMES.replace('/', ''), 'tickets-einstant-sort-games', ALPHABETICAL, 60),
    _svs$eInstant$shared$4 = _slicedToArray(_svs$eInstant$shared$3, 2),
    selected = _svs$eInstant$shared$4[0],
    setSelected = _svs$eInstant$shared$4[1];
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    games = _useState2[0],
    setGames = _useState2[1];
  const _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  const loaderRef = useRef();
  const sortFn = (_getSortOptionById = getSortOptionById(selected)) === null || _getSortOptionById === void 0 ? void 0 : _getSortOptionById.sortFn;
  useEffect(() => {
    const sortedGames = sortFn === null || sortFn === void 0 ? void 0 : sortFn([...games]);
    sortedGames && setGames(sortedGames);
  }, [selected]);
  useEffect(() => {
    !gameUrl && update(ALL_GAMES);
  }, [gameUrl]);
  useEffect(() => {
    let loader;
    if (loading && loaderRef.current) {
      loader = new svs.ui.Loader(loaderRef.current, {
        delayedShow: false
      }).show(300);
    }
    fetchAllGames().then(games => setGames((sortFn === null || sortFn === void 0 ? void 0 : sortFn([...games])) || games)).catch(() => setError(true)).finally(() => {
      setLoading(false);
      if (loader) {
        loader.hide();
      }
    });
  }, []);
  useEffect(() => {
    if (error) {
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.ERROR,
        title: 'Kunde inte hämta spel',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: 'Försök igen senare eller kontakta kundservice.'
        }],
        actions: [{
          title: 'Okej',
          callback: () => {
            dialog.close();
            history.push(LOBBY);
          }
        }]
      });
      svs.ui.dialog.api.add(dialog);
    }
  }, [error, history, LOBBY]);
  const routeUrl = "".concat(svs.core.data.baseUrl).concat(ALL_GAMES);
  return React.createElement(Background, null, React.createElement(InfoOverlay, {
    onCloseUrl: routeUrl
  }), React.createElement(ScrollToTop, null), React.createElement("div", {
    className: "tickets-einstant-max-width w100"
  }, React.createElement("div", {
    className: "u-flex u-flex-column margin-v-2 margin-h-1"
  }, React.createElement(GridRow, {
    className: "u-flex u-flex-align-items-center",
    gutter: "0"
  }, React.createElement(GridCol, {
    am: 8,
    lg: 10,
    md: 8,
    xs: 12
  }, React.createElement("div", {
    className: "tickets-einstant-special-width-header"
  }, React.createElement("div", {
    className: "u-flex u-flex-column margin-top-1"
  }, React.createElement("div", {
    className: "f-body u-flex u-flex-row u-flex-align-items-center margin-bottom-2"
  }, React.createElement(Icon, {
    color: "fc-fler-lotter-new-700 margin-right-half",
    icon: "all-card-games",
    size: 500
  }), React.createElement("h1", {
    className: "h1 fc-fler-lotter-new-700 margin-0"
  }, "Alla spel"))))), React.createElement(GridCol, {
    am: 4,
    className: "tickets-einstant-margin-left-auto",
    lg: 2,
    md: 4,
    xs: 12
  }, React.createElement(SortGames, {
    hideDefault: true,
    placeholderLabel: "Sortera",
    selected: selected,
    setSelected: setSelected
  }))), React.createElement("div", {
    className: "margin-top-1-half"
  }, loading ? React.createElement("div", {
    className: "relative align-center margin-v-3 tickets-einstant-loader",
    ref: loaderRef
  }) : error ? React.createElement("div", {
    className: "u-flex u-flex-justify-content-center margin-v-3"
  }, React.createElement("h4", {
    className: "h4 fc-fler-lotter-new-700"
  }, "Ett fel uppstod vid laddning av alla spel.")) : React.createElement(GameGrid, {
    games: games
  })))));
};
setGlobal('svs.eInstant.lobby.AllGames', AllGames);

 })(window);